import { faCheckSquare } from "@fortawesome/pro-regular-svg-icons/faCheckSquare";
import { faSquare } from "@fortawesome/pro-regular-svg-icons/faSquare";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons/faCheckCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Theme } from "@mui/material";
import { createStyles, withStyles, WithStyles } from "@mui/styles";
import classNames from "classnames";
import { KnowledgeTestSelectionMode } from "models/ApiEnums";
import { KnowledgeTestAnswersDistributionModel } from "models/ApiModels";
import * as React from "react";

/////////////////////////////////////////////////////////////////////////////////////

const styles = (theme: Theme) => createStyles({
    pollGraphContainer: {
        position: "relative",
        lineHeight: "32px",
        marginBottom: 2
    },
    pollGraphLabel: {
        position: "absolute",
        top: 0,
        paddingLeft: theme.spacing(1),
        whiteSpace: 'nowrap',
        width: "100%",
        textOverflow: "ellipsis",
        overflow: "hidden"
    },
    pollGraphBar: {
        backgroundColor: theme.palette.error.main,
        borderRadius: "10px",
        height: "100%"
    },
    pollGraphBarWin: {
        backgroundColor: theme.genie.palette.success.main,
        borderRadius: "10px",
        height: "100%"
    },
    pollGraphBarMulti: {
        display: "inline-block"
    },
    pollGraphMultiLabel: {
        whiteSpace: 'nowrap',
        width: "100%",
        textOverflow: "ellipsis",
        overflow: "hidden"
    },
    pollGraphPercent: {
        width: "1px",
        textAlign: "right"
    },
    pollGraphTable: {
        width: "100%"
    },
    pollOption: {
        borderRadius: "10px",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: theme.genie.palette.info.main,
        backgroundColor: theme.palette.common.white,
        color: theme.genie.palette.info.main,
        padding: theme.spacing(1),
        marginBottom: 4,
    },
});

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    data: KnowledgeTestAnswersDistributionModel[];
}

type Props = IProps & WithStyles<typeof styles>;

/////////////////////////////////////////////////////////////////////////////////////

class KnowledgeTestAnswersGraph extends React.PureComponent<Props>{

    public render() {

        const { classes, data } = this.props;
        const totalAnswers = data?.length == 0
            ? 0
            : data[0].answerSelectionMode == KnowledgeTestSelectionMode.Simple
                ? data.map(x => x.totalAnswers).reduce((p, c) => p + c)
                : data[0].totalAnswers;

        var table = data.map((v, index) => {
            if (v.answerSelectionMode == KnowledgeTestSelectionMode.Simple) {
                const p = totalAnswers == 0 ? 0 : Math.round(v.totalAnswers / totalAnswers * 100);
                return (
                    <tr key={index}>
                        <td>
                            <div className={classes.pollGraphContainer}>
                                <div className={classes.pollGraphLabel}>
                                    {
                                        v.shouldBeSelected
                                            ? <span><small><FontAwesomeIcon icon={faCheckCircle} /></small> {v.text}</span>
                                            : <span>{v.text}</span>
                                    }
                                </div>
                                <div className={v.shouldBeSelected ? classes.pollGraphBarWin : classes.pollGraphBar} style={{ width: p + "%" }}>
                                    <span>&nbsp;</span>
                                </div>
                            </div>
                        </td>
                        <td className={classes.pollGraphPercent}>
                            {
                                v.shouldBeSelected
                                    ? <b><span>{p}%</span></b>
                                    : <span>{p}%</span>
                            }
                        </td>
                    </tr>
                );
            }
            else {
                const p = totalAnswers == 0 ? 0 : Math.round(v.totalCorrect / totalAnswers * 100);
                const pCorrect = p + "%";
                const pWrong = (totalAnswers == 0 ? 0 : (100 - p)) + "%";
                return (
                    <React.Fragment key={index}>
                        <tr>
                            <td>
                                <div>
                                    {
                                        v.shouldBeSelected
                                            ? <FontAwesomeIcon icon={faCheckSquare} />
                                            : <FontAwesomeIcon icon={faSquare} />
                                    }
                                    <b>&nbsp;{v.text}</b>
                                </div>
                            </td>
                        </tr>
                        {
                            totalAnswers > 0 &&
                            <tr>
                                <td>
                                    <div className={classes.pollGraphContainer}>
                                        {
                                            p > 0 &&
                                            <div className={classNames(classes.pollGraphBarWin, classes.pollGraphBarMulti, classes.pollGraphMultiLabel)} style={{ width: pCorrect }}>
                                                <span>{pCorrect}</span>
                                            </div>
                                        }
                                        {
                                            p < 100 &&
                                            <div className={classNames(classes.pollGraphBar, classes.pollGraphBarMulti, classes.pollGraphMultiLabel)} style={{ width: pWrong }}>
                                                <span>{pWrong}</span>
                                            </div>
                                        }
                                    </div>
                                </td>
                            </tr>
                        }
                    </React.Fragment>
                );
            }
        });

        return <table className={classes.pollGraphTable}> {table}</table >;
    }
}

export default withStyles(styles)(KnowledgeTestAnswersGraph);